import { useContext, useState } from "react";
import FilterReportDateItens from "../../../../components/filter/reportDateItens/filter";
import reqContaEntrada from "../../../../services/reqMultiTenant/reqContaEntrada";
import { RegisterProvider, ContextRegister } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import Form from "../form";
import { ContextGlobal } from "../../../../context";
import FormManagerConfig from "../Manager";
import { gerarPdfVendaCompleta } from "../../../../util/reports/report-sale-complete";
import Notification from "../../../../components/toast";
import { useNavigate } from "react-router-dom";
import reqCliente from "../../../../services/reqMultiTenant/reqCliente";
import reqPedido from "../../../../services/reqMultiTenant/reqPedido";
import reqVenda from "../../../../services/reqMultiTenant/reqVenda";
import ModalMain from "../../../../components/modal";
import AlterarVenda from "../../../movimentacao/alterar-venda";

const MainRegisterAccountEntry = () => {
	const { enterpriseData } = useContext(ContextGlobal);
	const navigate = useNavigate();
	const [selectedIdVenda, setSelectedIdVenda] = useState(null);
	const identForm = "account-entry";

	const handleGenerateSaleReport = async (item) => {
		try {
			const isConsumidorFinal = item.id_cliente === 1;

			const fetchClientData = isConsumidorFinal
				? item.id_venda
					? reqPedido.listByVenda(item.id_venda)
					: Promise.resolve({ data: null })
				: item.id_cliente
					? reqCliente.listID(item.id_cliente)
					: Promise.resolve({ data: null });

			const [groupRes, itensRes, clienteRes, complementosRes, vendaRes] = await Promise.allSettled([
				item.id_venda ? reqContaEntrada.listIDGroup(item.id_venda) : Promise.resolve({ data: [] }),
				item.id_venda ? reqContaEntrada.listVendaItens(item.id_venda) : Promise.resolve({ data: [] }),
				fetchClientData,
				item.id_venda ? reqContaEntrada.listVendaComplementos(item.id_venda) : Promise.resolve({ data: [] }),
				item.id_venda ? reqVenda.listCupom(item.id_venda) : Promise.resolve({ data: null }),
			]);

			const installments = groupRes.status === "fulfilled" ? (groupRes.value.data ?? []) : [];
			const products = itensRes.status === "fulfilled" ? (itensRes.value.data ?? []) : [];
			const clientData = clienteRes.status === "fulfilled" ? (clienteRes.value.data ?? null) : null;
			const complements = complementosRes.status === "fulfilled" ? (complementosRes.value.data ?? []) : [];

			const vendaPayload = vendaRes.status === "fulfilled" ? (vendaRes.value.data ?? null) : null;
			const saleHeader = Array.isArray(vendaPayload) ? (vendaPayload[0] ?? null) : vendaPayload;

			gerarPdfVendaCompleta({
				saleData: item,
				saleHeader,
				installments,
				products,
				complements,
				clientData,
				empresa: enterpriseData?.nome ?? "SZ Sistemas",
			});
		} catch (error) {
			Notification.showToast({ message: "Erro ao gerar relatório da venda.", type: "error" });
		}
	};

	const options = {
		id: "id_conta_entrada", //usado para saber qual field usar para atualizar
		ident: `register${identForm}`, //usado para definir os event listners
		identFilter: `filter${identForm}`, //usado para definir os event listners
		title: "Receitas",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "id_venda", label: "Cod. Venda", align: "left", width: "100px" },
			{ key: "nome", label: "Nome", align: "left", width: "250px" },
			{ key: "valor", label: "Valor", align: "left", format: "currency", width: "150px" },
			{ key: "ativo", label: "Status", align: "left", format: "badgePgto", width: "120px", clickable: true },
			{ key: "parcela_numero", label: "Parcela", align: "center", width: "150px" },
			{ key: "data", label: "Data Venc.", align: "left", format: "date", width: "170px" },
			{ key: "forma", label: "Forma Pgto", align: "left", width: "170px" },
			{ key: "datapgto", label: "Dt. Pagamento", align: "left", format: "date" },
			// aqui entraremos com condicional
			...(enterpriseData?.id_empresa === 1 ? [{ key: "action_config", label: "", align: "right" }] : []),

			{ key: "actions", label: "", align: "right" },
		],
		identReport: `report${identForm}`, //usado para definir os event listners
		reportColumns: [
			{ key: "nome", label: "Cliente", align: "left", visible: true },
			{ key: "valor", label: "Valor", align: "right", format: "currency", visible: true },
			{ key: "parcela", label: "Parcela", align: "center", visible: true },
			{ key: "parcela_total", label: "Total Parcelas", align: "center", visible: true },
			{ key: "forma", label: "Forma Pgto", align: "left", visible: true },
			{ key: "ativo", label: "Ativo", align: "center", format: "badgePgto", visible: true },
			{ key: "data", label: "Dt. Parcela", align: "left", format: "date", visible: false },
			{ key: "datavenda", label: "Dt. Venda", align: "left", format: "datetime", visible: false },
			{ key: "caixa", label: "Caixa", align: "center", visible: false },
			{ key: "soma", label: "Total Venda", align: "right", format: "currency", visible: false },
		],
		parametersDate: [
			{ id: 1, label: "Dt. Venda", value: "dtVenda" },
			{ id: 2, label: "Dt. Vencimento", value: "dtVencimento" },
		],
		showTime: true, //mostra a hora no filtro de data
		hasActive: true,
		activeLabel: { true: "Pendente", false: "Pago" },
		hasSaleType: false,
		hasSum: true,
		listDataTotal: [
			{ key: "soma", label: "Soma Total", format: "currency" },
		],
		parametersFilter: [
			{ id: 1, label: "Cliente", value: "cliente" },
			{ id: 2, label: "Vendedor", value: "vendedor" },
			{ id: 3, label: "Forma Pagamento", value: "formaPgto" },
			{ id: 4, label: "Código da venda", value: "codVenda" },
		],
		onReport: handleGenerateSaleReport,
		onAlterarVenda: (item) => {
			if (item.id_venda) {
				setSelectedIdVenda(item.id_venda);
				const event = new CustomEvent("modalAlterarVenda");
				window.dispatchEvent(event);
			} else {
				Notification.showToast({ message: "Esta receita não possui uma Venda atrelada.", type: "warning" });
			}
		},
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const newFilterData = { ...filterData, page: newPage, perPage };

		const response = await reqContaEntrada.listPaginate(newFilterData);

		return response;
	};

	const fetchSum = async (filterData) => {
		const response = await reqContaEntrada.listContaEntradaSum(filterData);
		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqContaEntrada.listID(currentId);

		return response;
	};

	const fetchIdGroup = async (currentId) => {
		const response = await reqContaEntrada.listIDGroup(currentId);
		return response;
	};

	const insert = async (data) => {
		const response = await reqContaEntrada.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert} fetchIdGroup={fetchIdGroup} fetchSum={fetchSum}>
			<AccountEntryContent selectedIdVenda={selectedIdVenda} setSelectedIdVenda={setSelectedIdVenda} />
		</RegisterProvider>
	);
};

const AccountEntryContent = ({ selectedIdVenda, setSelectedIdVenda }) => {
	const { reloadFetchFirstData } = useContext(ContextRegister);
	const [houveAlteracao, setHouveAlteracao] = useState(false);

	const handleCloseModal = () => {
		if (selectedIdVenda && houveAlteracao) {
			reloadFetchFirstData(0, selectedIdVenda);
		}
		setSelectedIdVenda(null);
		setHouveAlteracao(false);
	};

	return (
		<>
			<MainRegisterMatrix FormComponent={Form} FormFilter={FilterReportDateItens} FormAux={FormManagerConfig} />
			<ModalMain
				ident="modalAlterarVenda"
				className="react-modal-content-base w-full max-w-[1250px] h-[95%] bg-white p-4 relative m-10"
				onClose={handleCloseModal}
			>
				{selectedIdVenda && (
					<AlterarVenda 
						idVendaProp={selectedIdVenda} 
						onAlteracao={() => setHouveAlteracao(true)} 
					/>
				)}
			</ModalMain>
		</>
	);
};

export default MainRegisterAccountEntry;
